import React, { useState } from "react";
import { Formik, Form } from "formik";
import PracticeTeamProvider, { usePracticeTeam } from "../../contexts/practice-team-context";
import StatesProvider from "../../contexts/states-context";
import { PracticeTeamFormContainer } from "../../components";
import { PracticeNameField, StateField } from "../../fields";
import { fieldTypes } from "../../constants";
import { updatePracticeTeam } from "../../apis";
import { translate } from "@td/shared_utils";
import { Toaster } from "@td/ui";
import { goToPracticeTeam } from "../../utils/url-helper";
import toastr from "toastr";

const PracticeTeamEdit = () => {
  const [errors, setErrors] = useState([]);
  const { practiceTeam } = usePracticeTeam();

  const handleSubmit = async (values) => {
    setErrors([]);

    const { errors } = await updatePracticeTeam({
      id: practiceTeam.globalId,
      name: values[fieldTypes.PRACTICE_NAME],
      states: values[fieldTypes.STATES].map(({ value }) => value),
    });

    if (errors.length) {
      setErrors(errors);
    } else {
      toastr.success(
        translate(null, "practice_team.editing", "notification")
      );

      goToPracticeTeam(practiceTeam.id);
    }
  };

  const initialValues = {
    [fieldTypes.PRACTICE_NAME]: practiceTeam.name,
    [fieldTypes.STATES]: practiceTeam.states.map((state) => ({
      value: state,
    })),
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
    >
      <React.Fragment>
        <h2 data-testid="practice-team-edit-header">
          {translate(null, "practice_team.editing", "header")}
        </h2>

        <Form>
          {errors.map((error, index) => (
            <div
              key={index}
              className="error"
              data-testid="practice-team-error"
            >
              {error}
            </div>
          ))}

          <PracticeTeamFormContainer>
            <PracticeNameField />
            <StateField />

            <div className="buttons">
              <button
                type="submit"
                className="button"
                data-testid="practice-team-edit-submit-button"
              >
                {translate(null, "practice_team.editing.actions", "save")}
              </button>
            </div>
          </PracticeTeamFormContainer>
        </Form>
      </React.Fragment>
    </Formik>
  );
};

const PracticeTeamEditContainer = (props) => (
  <PracticeTeamProvider {...props}>
    <StatesProvider>
      <PracticeTeamEdit {...props} />
      <Toaster />
    </StatesProvider>
  </PracticeTeamProvider>
);

PracticeTeamEditContainer.displayName = "PracticeTeamEditContainer";

export default PracticeTeamEditContainer;
